export default __webpack_public_path__ + "static/media/datepicker.0e8053e9.svg";